export default "__VITE_ASSET__CtbdsvP___"